import { doc, getDoc } from "firebase/firestore";
import { useMemo, useState } from "react";
import { db } from "../firebase";

function tryPrettyJson(value: any) {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function ThreadDebug() {
  const [threadId, setThreadId] = useState("");
  const [loading, setLoading] = useState(false);
  const [out, setOut] = useState<string>("");
  const [err, setErr] = useState<string>("");

  const canFetch = useMemo(() => threadId.trim().length > 5 && !loading, [threadId, loading]);

  async function fetchThread() {
    setErr("");
    setOut("");
    const id = threadId.trim();
    if (!id) return;

    setLoading(true);
    try {
      const snap = await getDoc(doc(db, "threads", id));
      if (!snap.exists()) {
        setErr(`Thread not found: ${id}`);
        return;
      }
      const data = snap.data();
      const json = tryPrettyJson({ id: snap.id, ...data });
      setOut(json);
    } catch (e: any) {
      setErr(e?.message || String(e));
    } finally {
      setLoading(false);
    }
  }

  async function copyOutput() {
    try {
      await navigator.clipboard.writeText(out || "");
      alert("Copied JSON to clipboard.");
    } catch {
      alert("Copy failed. Select the output text and copy it from the browser.");
    }
  }

  return (
    <div className="card" style={{ display: "grid", gap: 12 }}>
      <h2>Thread Access Diagnostics</h2>
      <p className="muted">
        Enter a thread ID to inspect its stored participants, student links, and message metadata.
      </p>

      <div style={{ display: "grid", gap: 8 }}>
        <label className="muted" style={{ display: "grid", gap: 6 }}>
          Thread ID
          <input
            className="input"
            value={threadId}
            onChange={(e) => setThreadId(e.target.value)}
            placeholder="e.g. direct_7d29986710bb4459c0f7f4b5d29537e0486a7752"
          />
        </label>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button className="btn" onClick={fetchThread} disabled={!canFetch}>
            {loading ? "Loading..." : "Inspect Thread"}
          </button>
          <button className="btn secondary" onClick={() => { setThreadId(""); setOut(""); setErr(""); }} disabled={loading}>
            Clear
          </button>
          <button className="btn secondary" onClick={copyOutput} disabled={!out || loading}>
            Copy Output
          </button>
        </div>
      </div>

      {err ? (
        <div className="card" style={{ border: "1px solid rgba(220,38,38,0.35)" }}>
          <b style={{ color: "#dc2626" }}>Error</b>
          <div className="muted" style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>{err}</div>
        </div>
      ) : null}

      <label className="muted" style={{ display: "grid", gap: 6 }}>
        Output
        <textarea
          className="input"
          style={{ minHeight: 360, fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" }}
          value={out}
          readOnly
        />
      </label>
    </div>
  );
}
